import { adminOidcConfigurationsByCustomerByIdDeleteSlice } from './delete';
import { adminOidcConfigurationsByCustomerByIdPostSlice } from './post';

export const {
	requestDeleteAdminOidcConfigurationsByCustomerById,
	resetDeleteAdminOidcConfigurationsByCustomerById
} = adminOidcConfigurationsByCustomerByIdDeleteSlice.asyncActionCreators;

export const {
	requestPostAdminOidcConfigurationsByCustomerById,
	resetPostAdminOidcConfigurationsByCustomerById
} = adminOidcConfigurationsByCustomerByIdPostSlice.asyncActionCreators;
